import { get } from 'lodash';

export default function getARIdFromPathname(pathname = '') {
  const regex = /^\/?assistance-requests\/(.*)\/(contacts|referrals)\/(.*)$/;
  const arId = get(pathname.match(regex), '[1]');

  return arId;
}
